// client/src/components/donations/GoalProgressBar.jsx
//
// Donation goal progress (Roadmap Phase 5.1). Used on the public give page,
// public event pages and the hub. With no goal it shows the amount raised.

import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatMoney } from '../../services/donationsApi';
import './Donations.css';

export default function GoalProgressBar({ raisedCents = 0, goalCents = null, donors = 0, currency = 'usd', title = null, href = null }) {
  const { t } = useTranslation();
  const pct = goalCents ? Math.min(100, Math.round((Number(raisedCents) / Number(goalCents)) * 100)) : null;
  const raised = formatMoney(raisedCents, currency);
  const text = goalCents
    ? t('donations.goal.raisedOf', '{{raised}} raised of {{goal}}', { raised, goal: formatMoney(goalCents, currency) })
    : t('donations.goal.raised', '{{raised}} raised', { raised });
  return (
    <div className="dn-goal" data-testid="goal-bar">
      {title && <p className="dn-goal-title">{title}</p>}
      {pct !== null && (
        <div className="dn-goal-track" role="progressbar" aria-label={text} aria-valuemin={0} aria-valuemax={100} aria-valuenow={pct}>
          <div className="dn-goal-fill" style={{ width: `${pct}%` }} />
        </div>
      )}
      <p className="dn-goal-text">
        <strong>{text}</strong>
        {' · '}
        {t('donations.goal.donors', '{{count}} donors', { count: Number(donors) || 0 })}
      </p>
      {href && <a className="dn-goal-link" href={href}>{t('donations.goal.give', 'Donate')}</a>}
    </div>
  );
}
